<template>
  <div
    v-if="blok && blok.slides && blok.slides.length"
    v-editable="blok"
    :class="marginClasses"
    class="my-2"
  >
    <h2
      class="mb-4 text-center text-xl leading-8 md:mb-6 md:text-2xl md:leading-9"
    >
      {{ blok.headline }}
    </h2>
    <BasicSlider
      :max-items-per-slide="5"
      :items="blok.slides"
      key-prop="_uid"
      @slide-visible="visibilityHandler"
    >
      <template #item="{ item, index }">
        <IconSliderSlide
          :blok="item"
          @click:icon-slide="trackSliderSlideClick($event, index)"
        />
      </template>
    </BasicSlider>
  </div>
</template>

<script setup lang="ts">
import type {
  SbIconSlider,
  SbIconSliderSlide,
} from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  blok: {
    type: Object as PropType<SbIconSlider>,
    default: () => {},
  },
})
const { marginClasses } = useStoryblokMargins(props.blok)
const { trackPromotionSelect, trackPromotionView } = useTrackingEvents()

const trackingCollector = ref<SbIconSliderSlide[]>([])

const trackSliderSlideClick = (_blok: SbIconSliderSlide, index: number) => {
  const promo = props.blok
  trackPromotionSelect({
    id: promo.promotion_id || 'icon_slider_promotion_id',
    name: promo.promotion_name || 'icon_slider_promotion_name',
    promoType: 'iconslider',
    position: index + 1,
    creativeNameSb: props.blok.creative_name || '',
  })
}

const visibilityHandler = (
  visibleItems: SbIconSliderSlide[],
  index: number,
) => {
  const untrackedItems = visibleItems?.filter(
    (item) => !trackingCollector.value.includes(item),
  )

  if (untrackedItems.length === 0) {
    return
  }

  untrackedItems.forEach(() => {
    const promo = props.blok
    trackPromotionView({
      id: promo.promotion_id || 'icon_slider_promotion_id',
      name: promo.promotion_name || 'icon_slider_promotion_name',
      promoType: 'iconslider',
      position: index + 1,
      creativeNameSb: props.blok.creative_name || '',
    })
  })

  trackingCollector.value.push(...untrackedItems)
}
</script>
